import styled, { css } from 'styled-components';
import { FlexDiv, GenericDiv, Headings } from 'common/Styles';

export const MessageContainer = styled.div`
	overflow: auto;
	padding: 24px 16px;
	max-height: calc(100% - 50px);
	h1 {
		font-size: 22px;
		margin: 10px 0;
	}
	h2 {
		font-size: 28px;
		margin: 8px 0;
	}
	h3 {
		font-size: 16px;
		font-weight: 700;
		margin: 5px 0;
	}
	h4 {
		font-size: 14px;
		font-weight: 700;
		margin: 5px 0;
	}
	li {
		margin: 5px 0;
	}
	p {
		margin: 5px 0;
	}
	strong {
		font-weight: 700;
	}
	ul {
		padding-left: 10px;
		list-style: disc;
	}
`;

// New styles for the redesigned chat interface
export const WelcomeContainerScroll = styled(FlexDiv)`
	max-height: 70%;
	overflow: auto;
`;

export const GreetingText = styled(Headings)`
	margin: 0 0 8px 0;
	background: linear-gradient(49deg, #F0772C 0%, #f8f5f5 100%) text;
	-webkit-text-fill-color: transparent;
`;

export const SubtitleText = styled(Headings)`
	color: #000;
	margin: 0 0 32px 0;
	
`;

export const SuggestionCard = styled(FlexDiv)`
	cursor: ${(props) => props.disabled ? 'not-allowed' : 'pointer'};
	opacity: ${(props) => props.disabled ? '0.5' : '1'};
	transition: all 0.2s ease;
	text-align: left;
	&:hover:not(:disabled) {
		border-color: #f1753180;
		box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
	}
	&:active:not(:disabled) {
		transform: scale(0.99);
	}
`;

export const SuggestionIcon = styled(FlexDiv)`
	svg, img {
		width: 20px;
		height: 20px;
	}
`;

export const ChatInput = styled.input`
	flex: 1;
	border: none;
	background: transparent;
	font-size: 15px;
	color: #1a1a1a;
	outline: none;

	&::placeholder {
		color: #9ca3af;
	}

	&:disabled {
		cursor: not-allowed;
	}
`;

export const SendButton = styled.button`
	width: 36px;
	height: 36px;
	background: transparent;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: ${(props) => props.disabled ? 'not-allowed' : 'pointer'};
	opacity: ${(props) => props.disabled ? '0.5' : '1'};
	transition: all 0.2s ease;
	margin-left: 12px;
	flex-shrink: 0;

	&:hover:not(:disabled) {
		background: #3b82f6;
		svg path {
			stroke: #ffffff;
		}
	}

	svg {
		width: 24px;
		height: 24px;
	}
`;

// Header styles
export const ChatHeader = styled(FlexDiv)`
	padding: 16px 24px;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #f0f0f0;
`;

export const MenuButton = styled.button`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	border: 1px solid #e5e7eb;
	background: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: #f5f5f5;
	}
`;

export const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
`;

export const LogoText = styled.span`
	font-size: 20px;
	font-style: italic;
	color: #f17531;
`;

export const BetaTag = styled.sup`
	font-size: 10px;
	font-style: normal;
	margin-left: 2px;
	vertical-align: super;
	color: #f17531;
`;

export const MyraIcon = styled.span`
	font-family: 'Georgia', 'Times New Roman', serif;
	font-style: italic;
	color: #3b82f6;
	font-size: 14px;
`;

// Action buttons for chat messages
export const ActionButton = styled.button`
	padding: 8px 16px;
	font-size: 13px;
	border-radius: 8px;
	margin-right: 8px;
	cursor: pointer;
	transition: all 0.2s ease;
	border: ${(props) => props.$variant === 'secondary' ? '1px solid #3b82f6' : 'none'};
	background: ${(props) => props.$variant === 'secondary' ? 'transparent' : '#3b82f6'};
	color: ${(props) => props.$variant === 'secondary' ? '#3b82f6' : '#ffffff'};

	&:hover {
		opacity: 0.9;
	}
`;

// Suggestion pill for follow-up questions
export const SuggestionPill = styled.button`
	padding: 16px 12px;
	font-size: 14px;
	font-weight: 500;
	border: 1px solid #f0f0f0;
	border-radius: 16px;
	background: #fdfdfd;
	margin-right: 8px;
	margin-bottom: 6px;
	cursor: ${(props) => props.disabled ? 'not-allowed' : 'pointer'};
	opacity: ${(props) => props.disabled ? '0.5' : '1'};
	transition: all 0.2s ease;

	&:hover:not(:disabled) {
		background: #f0f4ff;
	}
`;

// Message bubble
export const MessageBubble = styled.div`
	font-size: 15px;
	padding: 10px 12px;
	margin: 10px 0 10px;
	border-radius: 12px;
	max-width: 85%;
	align-self: ${(props) => props.$isUser ? 'flex-end' : 'flex-start'};
	background: ${(props) => props.$isUser ? '#f17531' : 'transparent'};
	color: ${(props) => props.$isUser ? '#fff' : '#0d0d0d'};
	${(props) => props.$isUser && css`
		border-radius: 16px 0 16px 16px;
		
	`}
`;
